// import {Icon} from '@ui-kitten/components';
import React, {useState} from 'react';
import {Image, Platform, StyleSheet} from 'react-native';
import {getImage} from '../../helpers/general';
import {px} from '../../utils';
import {SelectImageModal} from '../components';
import ImagePickerWeb from './ImagePickerWeb';

// const delIcon = (props) => <Icon {...props} fill="red" name="trash-outline" />;

const StudentImage = ({kidsImage, onImageChange}) => {
  const [imageData, setImageData] = useState(null);
  const [isSelectImageModalVisible, setIsSelectImageModalVisible] = useState(
    false,
  );

  const handleImageChange = (image) => {
    setImageData(image);
    // onImageChange(image);
  };

  if (Platform.OS === 'web') {
    return (
      <>
        <Image
          source={{
            uri: imageData?.[0]
              ? URL.createObjectURL(imageData[0])
              : getImage(kidsImage),
          }}
          resizeMode="contain"
          style={styles.avatar}
        />
        <ImagePickerWeb
          setSelectedImage={handleImageChange}
          imageData={imageData}
        />
      </>
    );
  }

  return (
    <>
      <Image
        source={{uri: imageData?.uri || getImage(kidsImage)}}
        resizeMode="contain"
        style={styles.avatar}
      />
      {/* disable change image */}
      {/* <Layout style={styles.imageButtonsRow}>
        <Button
          // appearance="ghost"
          onPress={() => setIsSelectImageModalVisible(true)}>
          {'Change image'}
        </Button>
        {Boolean(imageData) && (
          <Button
            appearance="ghost"
            status="danger"
            onPress={() => handleImageChange(undefined)}
          />
        )}
      </Layout> */}
      <SelectImageModal
        setImageData={handleImageChange}
        onClose={() => setIsSelectImageModalVisible(false)}
        visible={isSelectImageModalVisible}
      />
    </>
  );
};

const styles = StyleSheet.create({
  marginTop: {
    marginTop: px(20),
  },
  button: {
    marginTop: px(20),
    height: px(80),
  },
  imageButtonsRow: {
    flexDirection: 'row',
    marginTop: px(5),
  },
  imageStyle: {
    width: 100,
    height: 100,
  },
  avatar: {
    width: px(64),
    height: px(64),
    borderRadius: 50,
    backgroundColor: '#FFEDEF',
  },
});

export default StudentImage;
